import { __assign, __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
import { getBaseProps } from '../internal/base-component';
import styles from './styles.css.js';
import { Flash } from './flash';
import { useContainerBreakpoints } from '../internal/hooks/container-queries';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import useBaseComponent from '../internal/hooks/use-base-component';
import mergeRefs from 'react-merge-refs';
export default function Flashbar(_a) {
    var items = _a.items, restProps = __rest(_a, ["items"]);
    var __internalRootRef = useBaseComponent('Flashbar').__internalRootRef;
    var _b = useContainerBreakpoints(['xs']), breakpoint = _b[0], ref = _b[1];
    var baseProps = getBaseProps(restProps);
    return (React.createElement("div", __assign({}, baseProps, { className: clsx(baseProps.className, styles.flashbar, styles["breakpoint-" + breakpoint]), ref: mergeRefs([ref, __internalRootRef]) }), items && items.map(function (item, index) { return React.createElement(Flash, __assign({ key: index }, item)); })));
}
applyDisplayName(Flashbar, 'Flashbar');
//# sourceMappingURL=index.js.map